import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VueRouter from 'vue-router'
import App from './App.vue'
import VueResource from 'vue-resource'
import Vuelidate from 'vuelidate'
import translations from './translations'

import home from './components/Home.vue';
import about from './components/About.vue';
import services from './components/Services.vue';
import team from './components/Team.vue';
import resources from './components/Resources.vue';
import faq from './components/Faq.vue';
import contact from './components/Contact.vue';

// partial

// loading screen
import loadingScreen from './components/partial/_loading-screen.vue';
// header
import navigation from './components/partial/_navigation.vue';
import menuItems from './components/partial/_menu-items.vue';
// home
import homeEntry from './components/partial/_home-entry.vue';
import homeAbout from './components/partial/_home-about.vue';
// import homeEmployeeHighlight from './components/partial/_home-employee-highlight.vue';
import homeServices from './components/partial/_home-services.vue';
import homeTeam from './components/partial/_home-team.vue';
// about
import aboutEntry from './components/partial/_about-entry.vue';
import aboutHistory from './components/partial/_about-history.vue';
import aboutNextPage from './components/partial/_about-next-page.vue';
// services
import servicesEntry from './components/partial/_services-entry.vue';
import servicesVariant1 from './components/partial/_services-variant-1.vue';
import servicesVariant2 from './components/partial/_services-variant-2.vue';
import servicesVariant3 from './components/partial/_services-variant-3.vue';
import servicesVariant4 from './components/partial/_services-variant-4.vue';
import servicesVariant5 from './components/partial/_services-variant-5.vue';
import servicesVariant6 from './components/partial/_services-variant-6.vue';
import servicesNextPage from './components/partial/_services-next-page.vue';
// team
import teamEntry from './components/partial/_team-entry.vue';
import teamNextPage from './components/partial/_team-next-page.vue';
import teamProfileVariant1 from './components/partial/_team-profile-variant-1.vue';
import teamProfileVariant2 from './components/partial/_team-profile-variant-2.vue';
import teamProfileVariant3 from './components/partial/_team-profile-variant-3.vue';
// import teamProfileVariant4 from './components/partial/_team-profile-variant-4.vue';
// resources
import resourcesEntry from './components/partial/_resources-entry.vue';
import resourcesGlossary from './components/partial/_resources-glossary.vue';
import resourcesNextPage from './components/partial/_resources-next-page.vue';
// faq
import faqEntry from './components/partial/_faq-entry.vue';
import faqNextPage from './components/partial/_faq-next-page.vue';
import faqQuestions from './components/partial/_faq-questions.vue';
// footer
import footerNavigation from './components/partial/_footer.vue';
// form
import form from './components/partial/_form.vue';

// Register Components for use

// Global
Vue.component('navigation', navigation);
Vue.component('menuItems', menuItems);
Vue.component('footerNavigation', footerNavigation);
// Pre Home Loading Screen
Vue.component('loadingScreen', loadingScreen);
// Home
Vue.component('homeEntry', homeEntry);
Vue.component('homeAbout', homeAbout);
// Vue.component('homeEmployeeHighlight', homeEmployeeHighlight);
Vue.component('homeServices', homeServices);
Vue.component('homeTeam', homeTeam);
// About
Vue.component('aboutEntry', aboutEntry);
Vue.component('aboutHistory', aboutHistory);
Vue.component('aboutNextPage', aboutNextPage);
// Services
Vue.component('servicesEntry', servicesEntry);
Vue.component('servicesVariant1', servicesVariant1);
Vue.component('servicesVariant2', servicesVariant2);
Vue.component('servicesVariant3', servicesVariant3);
Vue.component('servicesVariant4', servicesVariant4);
Vue.component('servicesVariant5', servicesVariant5);
Vue.component('servicesVariant6', servicesVariant6);
Vue.component('servicesNextPage', servicesNextPage);
// team
Vue.component('teamEntry', teamEntry);
Vue.component('teamNextPage', teamNextPage);
Vue.component('teamProfileVariant1', teamProfileVariant1);
Vue.component('teamProfileVariant2', teamProfileVariant2);
Vue.component('teamProfileVariant3', teamProfileVariant3);
// Vue.component('teamProfileVariant4', teamProfileVariant4);
// resources
Vue.component('resourcesEntry', resourcesEntry);
Vue.component('resourcesGlossary', resourcesGlossary);
Vue.component('resourcesNextPage', resourcesNextPage);
// faq
Vue.component('faqEntry', faqEntry);
Vue.component('faqNextPage', faqNextPage);
Vue.component('faqQuestions', faqQuestions);
// contact
Vue.component('formContact', form);

var vueSmoothScroll = require('vue-smoothscroll');

Vue.config.productionTip = false
Vue.use(VueResource)
Vue.use(VueI18n)
Vue.use(VueRouter)
Vue.use(vueSmoothScroll)
Vue.use(Vuelidate)

const routes = [
  { path: '/', component: home },
  { path: '/about', component: about },
  { path: '/services', component: services },
  { path: '/team', component: team },
  { path: '/resources', component: resources },
  { path: '/faq', component: faq },
  { path: '/contact', component: contact },
];

const router = new VueRouter({
  mode: 'history',
  routes
});

// Translation

const i18n = new VueI18n({
  locale: 'fr', // set locale
  messages: translations
})

new Vue({
  render: h => h(App),
  router,
  i18n
}).$mount('#app')
